import { withApiActions } from './apiActionHelper';

function loginAction(email, password) {
  return withApiActions(
    (api) => api.login(email, password),
    'LOGIN'
  );
}

export default loginAction;